import { FeedTag } from "@pages/Keyword/utils/types";

/**
 * Checks if a tag is a Budget 2026 tag.
 * @param tags - The tags to check.
 * @param path - The path of the budget 2026 tag.
 * @returns {boolean} - True if the tag is a Budget 2026 tag, false otherwise.
 */
export const isBudget2026Tag = (tags: FeedTag[], path: string): boolean => {
  return tags.some(
    ({ urlPath, urlPathHistory = [] }) =>
      urlPath === path || urlPathHistory.includes(path)
  );
};
